export default __webpack_public_path__ + "static/media/img-5.da24b2e5.png";